import { render, staticRenderFns } from "./RestCard.vue?vue&type=template&id=30cbd7cc&scoped=true"
import script from "./RestCard.vue?vue&type=script&lang=js"
export * from "./RestCard.vue?vue&type=script&lang=js"
import style0 from "./RestCard.vue?vue&type=style&index=0&id=30cbd7cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cbd7cc",
  null
  
)

export default component.exports